module.exports = __webpack_public_path__ + "static/media/separate_entrance_exit.a55cde02.svg";